import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Routes } from '@share/constants';

import './style.scss';

interface IProps {
  accountName?: string;
}

export function RewardsHero(props: IProps) {
  const { accountName } = props;
  const searchPath = accountName ? `/${accountName}${Routes.Search}` : '#';

  return (
    <>
      <div className="rewards-hero">
        <div className="rewards-hero__inner">
          <div className="rewards-hero__text">
            <p className="rewards-hero__brand">
              <FormattedMessage id="rewardsLearn.heroBrand" />
            </p>
            <h2 className="rewards-hero__title">
              <FormattedMessage id="rewardsLearn.heroTitle" />
            </h2>
            <p className="rewards-hero__desc">
              <FormattedMessage id="rewardsLearn.heroDesc" />
            </p>
            <Link to={searchPath} className="rewards-hero__cta">
              <FormattedMessage id="rewardsLearn.heroCta" />
            </Link>
          </div>
          <div className="rewards-hero__image" />
        </div>
      </div>
      <div className="rewards-hero__cards">
        <div className="rewards-hero__cards-item">
          <span className="rewards-hero__cards-icon" aria-hidden="true">🏨</span>
          <h3 className="rewards-hero__cards-title">
            <FormattedMessage id="rewardsLearn.card1Title" />
          </h3>
          <p className="rewards-hero__cards-desc">
            <FormattedMessage id="rewardsLearn.card1Desc" />
          </p>
        </div>
        <div className="rewards-hero__cards-item">
          <span className="rewards-hero__cards-icon" aria-hidden="true">🎁</span>
          <h3 className="rewards-hero__cards-title">
            <FormattedMessage id="rewardsLearn.card2Title" />
          </h3>
          <p className="rewards-hero__cards-desc">
            <FormattedMessage id="rewardsLearn.card2Desc" />
          </p>
        </div>
        <div className="rewards-hero__cards-item">
          <span className="rewards-hero__cards-icon" aria-hidden="true">👛</span>
          <h3 className="rewards-hero__cards-title">
            <FormattedMessage id="rewardsLearn.card3Title" />
          </h3>
          <p className="rewards-hero__cards-desc">
            <FormattedMessage id="rewardsLearn.card3Desc" />
          </p>
        </div>
      </div>
    </>
  );
}
